var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"container"},[_c('section',{staticClass:"title_box"},[_c('img',{attrs:{"src":require("../assets/images/act_success.png")}}),_c('p',[_vm._v(_vm._s(_vm.title)+"!")])]),_c('p',{staticClass:"desc"},[_vm._v(_vm._s(_vm.desc))]),_c('p',{staticClass:"back_btn submit_btn",on:{"click":_vm.backFun}},[_vm._v("返回")])])
}
var staticRenderFns = []

export { render, staticRenderFns }